import googleBadge from "../assets/GooglePlayBadge.png";
import appleBadge from "../assets/AppleStoreBadge.svg";
import useDeviceTypeHandler from "../hooks/device_type_handler_hook";

const Install = () => {
  const deviceType = useDeviceTypeHandler();

  const __renderStoreBadges = () => {
    if (deviceType === "android") {
      return (
        <a
          href="https://play.google.com/store/apps/details?id=com.vespid.mobileapp"
          target="_blank"
          rel="noreferrer"
          className="mt-4 px-4 py-2"
        >
          <img
            src={googleBadge}
            alt="Google Play Store Badge"
            className="w-40 h-auto"
          />
        </a>
      );
    } else if (deviceType === "iphone") {
      return (
        <a
          href="https://apps.apple.com/us/app/vespid/id6744089122"
          target="_blank"
          rel="noreferrer"
          className="mt-4 px-4 py-2"
        >
          <img
            src={appleBadge}
            alt="Apple App Store Badge"
            className="w-40 h-auto"
          />
        </a>
      );
    } else {
      return (
        <div className="flex flex-col md:flex-row justify-center items-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.vespid.mobileapp"
            target="_blank"
            rel="noreferrer"
            className="mt-4 px-4 py-2"
          >
            <img
              src={googleBadge}
              alt="Google Play Store Badge"
              className="w-40 h-auto"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/vespid/id6744089122"
            target="_blank"
            rel="noreferrer"
            className="mt-4 px-4 py-2"
          >
            <img
              src={appleBadge}
              alt="Apple App Store Badge"
              className="w-40 h-auto"
            />
          </a>
        </div>
      );
    }
  };

  return (
    <div className="max-w-screen-xl lg:mx-auto my-10 px-8 font-primaryFont font-light">
      <div className=" flex flex-col justify-center items-center">
        <h1 className="text-2xl text-center">Install Vespid Now!</h1>
        <h2 className=" mt-20 text-xl text-center">
          Install the Vespid app and use the same login credentials you entered.
          Please do not register another account.
        </h2>
        {__renderStoreBadges()}
      </div>
    </div>
  );
};

export default Install;
